const getPriceWithOrWithoutSale = ({
  sales = [],
  quantity = 0,
  product = {},
}) => {
  const findedSale = sales && sales.length
    ? sales[0].settings.find(({
      fromQuantity,
      toQuantity,
    }) => (quantity > fromQuantity && quantity < toQuantity)
      || quantity === fromQuantity
      || quantity === toQuantity) : null;

  const {
    price = 0,
    additionalDiscount: saleAdditionalDiscount = 0,
    isPercentage,
  } = findedSale || product || {};

  const additionalDiscount = isPercentage
    ? price * (saleAdditionalDiscount / 100)
    : saleAdditionalDiscount;

  return {
    price,
    additionalDiscount,
    saleAdditionalDiscount,
    findedSale,
    isPercentage,
  };
};

export default getPriceWithOrWithoutSale;
